import React, { useState, useEffect } from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import { mockAuth } from "./mock";
import Login from "./pages/Login";
import AdminLayout from "./pages/AdminLayout";

import CustomerLayout from "./customer/CustomerLayout";
import Home from "./customer/pages/Home";
import CarsList from "./customer/pages/CarsList";
import CarDetail from "./customer/pages/CarDetail";
import Checkout from "./customer/pages/Checkout";
import Confirmation from "./customer/pages/Confirmation";
import LocationsPage from "./customer/pages/LocationsPage";
import About from "./customer/pages/About";
import ContactHelp from "./customer/pages/ContactHelp";
import SignIn from "./customer/pages/SignIn";
import SignUp from "./customer/pages/SignUp";
import AuthCallback from "./customer/pages/AuthCallback";
import VerifyEmail from "./customer/pages/VerifyEmail";
import Profile from "./customer/pages/Profile";
import MyBookings from "./customer/pages/MyBookings";

function AdminApp() {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("dams_token");
    if (saved) setAuthed(true);
  }, []);

  const handleLoggedIn = () => setAuthed(true);

  const handleLogout = () => {
    localStorage.removeItem("dams_token");
    localStorage.removeItem("dams_user");
    setAuthed(false);
  };

  return !authed ? (
    <Login onLoggedIn={handleLoggedIn} />
  ) : (
    <AdminLayout onLogout={handleLogout} />
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <CustomerLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "cars", element: <CarsList /> },
      { path: "cars/:id", element: <CarDetail /> },
      { path: "checkout", element: <Checkout /> },
      { path: "confirmation", element: <Confirmation /> },
      { path: "payment-success", element: <Confirmation /> },
      { path: "payment-cancel", element: <Confirmation /> },
      { path: "checkout/success", element: <Confirmation /> },
      { path: "checkout/cancel", element: <Confirmation /> },
      { path: "locations", element: <LocationsPage /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <ContactHelp /> },
      { path: "help", element: <ContactHelp /> },
      { path: "sign-in", element: <SignIn /> },
      { path: "sign-up", element: <SignUp /> },
      { path: "auth/callback", element: <AuthCallback /> },
      { path: "verify-email", element: <VerifyEmail /> },
      { path: "profile", element: <Profile /> },
      { path: "my-bookings", element: <MyBookings /> },
    ],
  },
  { path: "/admin", element: <AdminApp /> },
  { path: "*", element: <Navigate to="/" replace /> },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
